import type {
  ModuleEntity,
  Statistics,
} from '@/domains/careerLayer/careerLayer.entity';

/**
 * UseCase para calcular estadísticas agregadas de módulos de CareerLayer
 *
 * Responsabilidades:
 * - Calcular total de módulos
 * - Calcular total de estudiantes sumando todos los módulos
 * - Calcular total de estudiantes en riesgo
 * - Calcular porcentaje de riesgo sobre el total
 * - Retornar estadísticas consolidadas
 */
export class CalculateCareerLayerStatisticsUseCase {
  /**
   * Ejecuta el cálculo de estadísticas sobre un conjunto de módulos
   * @param modules - Array de módulos a procesar
   */
  execute(modules: ModuleEntity[]): Statistics {
    const totalModulos = modules.length;
    const totalEstudiantes = modules.reduce(
      (sum, m) => sum + m.cantidad_estudiantes,
      0,
    );
    const estudiantesRiesgo = modules.reduce(
      (sum, m) => sum + m.estudiantes_con_riesgo,
      0,
    );
    const porcentajeRiesgo =
      totalEstudiantes > 0
        ? Math.round((estudiantesRiesgo / totalEstudiantes) * 100)
        : 0;

    return {
      totalModulos,
      totalEstudiantes,
      estudiantesRiesgo,
      porcentajeRiesgo,
    };
  }
}
